import { defineStore } from 'pinia';
import { ref } from 'vue';
import useBookingStore from './booking';
import type { SelectedArticle } from '../types/common';
import type { ArticleWithActionCode } from '../../../types/action-code';

const useFormProductStore = defineStore('form-product', () => {
  const bookingStore = useBookingStore();

  const selections = ref<SelectedArticle[]>([{
    name: 'serviceFee',
    article: bookingStore.articles.find(({ term }) => term === 'Bereitstellungspreis')!,
  }]);
  const appliedActionCode = ref<string>('');

  function applyActionCode(actionCode: string, discountArticles: ArticleWithActionCode[]): void {
    appliedActionCode.value = actionCode;

    discountArticles.forEach(discountArticle => {
      const candidate = selections.value.find(
        ({ article }) => article.articleNumber === discountArticle.discountRelatedToArticleNumber,
      );
      if (!candidate) {
        return;
      }
      candidate.article.isDiscountApplied = true;
      const correspondingArticle = bookingStore
        .applyDiscountToArticle(discountArticle.discountRelatedToArticleNumber);

      const {
        amount,
        article,
        articleNumber,
        description,
        price,
      } = discountArticle;
      const { monthlyPrice = null } = correspondingArticle ?? {};

      selections.value.push({
        name: article,
        article: {
          term: article,
          value: description,
          monthlyPrice: (amount > 1 ? monthlyPrice : null),
          onetimePrice: (amount <= 1 ? price * -1 : null),
          promoPrice: (monthlyPrice ? monthlyPrice - price : null),
          promoRuntime: amount,
          articleNumber,
          minDurationMonths: null,
          disabledReason: '',
          disabled: false,
          type: 'discount',
          isDiscountApplied: false,
        },
      });
    });
  }

  function clearDiscounts(): void {
    const candidates = selections
      .value
      .filter(selection => selection.article.type !== 'discount');

    candidates.forEach(selection => {
      selection.article.isDiscountApplied = false;
    });

    selections.value = candidates;
    bookingStore.clearDiscounts();
  }

  return {
    selections,
    appliedActionCode,
    applyActionCode,
    clearDiscounts,
  };
});

export default useFormProductStore;
